/* ===========================================================================
   AITO — Shopify Customer Privacy banner: copy + layout guard

   1) Korvaa Shopifyn defaulttitekstin AITO-rekisterillä. Käyttötarkoitukset
      (analytiikka + mainonta) ja se ettei mitään aja ennen suostumusta
      säilyvät lauseessa — tiivistys ei ole sisällön poistoa.
   2) Varaa bannerin korkeuden verran tilaa sivun alalaitaan niin kauan kuin
      banneri on näkyvissä. Ilman tätä fixed-palkki peittää sivun alaosan
      sisältöä — mobiilissa tuotesivulla juuri ADD TO CART -napin.

   Shopifyn skripti injektoi bannerin myöhään ja voi rendata sen uudelleen,
   siksi MutationObserver eikä kertaluontoinen ajo.
   ========================================================================= */
(function () {
  'use strict';

  var BANNER_ID = 'shopify-pc__banner';
  var COPY = 'cookies for analytics, ads and personalization. not the edible kind.';

  function rewriteCopy(banner) {
    var p = banner.querySelector('.shopify-pc__banner__body p');
    if (!p || p.dataset.aitoCopy === 'done') return;

    var link = p.querySelector('#shopify-pc__banner__body-policy-link');
    p.textContent = COPY + ' ';

    if (link) {
      link.textContent = 'privacy policy';
      p.appendChild(link);
    }

    p.dataset.aitoCopy = 'done';
  }

  function syncSpacer(banner) {
    var visible =
      banner &&
      banner.isConnected &&
      getComputedStyle(banner).display !== 'none' &&
      banner.offsetHeight > 0;

    if (visible) {
      document.body.style.setProperty(
        'padding-bottom',
        banner.offsetHeight + 'px'
      );
    } else {
      document.body.style.removeProperty('padding-bottom');
    }
  }

  function apply() {
    var banner = document.getElementById(BANNER_ID);
    if (banner) rewriteCopy(banner);
    syncSpacer(banner);
  }

  function start() {
    apply();

    new MutationObserver(apply).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    window.addEventListener('resize', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
